import { createProductExtensions } from './utils';
export { Editions } from './types';
export var startExtensionsWhitelist = ['edition', 'migrationSourceUuid'];
export var createStartExtensions = createProductExtensions(startExtensionsWhitelist);